import HttpService from "@core/services/http/http.service";
import {
  BankLink,
  ChangeInfoResponse,
  ChangePasswordRequest,
  GetDetailResponse,
  LoginResponse,
  SignUpRequest,
  SocialLoginRequest,
  UpdateAuthor,
  UserInfo,
  VerifyMfaCode,
  VerifyMfaSendMethodResponse,
} from "@app/types";
import { RequestContentType, Signal } from "@core/services/http/http.type";

class _AuthService {
  public login(email: string, password: string) {
    return HttpService.post<LoginResponse>("/admin/api/v2/auth/login", {
      body: {
        email,
        password,
      },
    });
  }

  public signUp(signUpRequest: SignUpRequest) {
    return HttpService.post<LoginResponse>("/user/api/v1/auth/register", {
      body: { ...signUpRequest },
    });
  }

  public getUserInfo(signal?: Signal) {
    return HttpService.get<GetDetailResponse<UserInfo>>(
      "/admin/api/v2/auth/info",
      { signal }
    );
  }

  public updateThumbnail(thumbnail: File) {
    return HttpService.patch("/admin/api/v2/auth/info/thumbnail", {
      body: { thumbnail },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public changeInfo(updateAdmin: UpdateAuthor) {
    return HttpService.patch<ChangeInfoResponse>("/admin/api/v2/auth/info", {
      body: { ...updateAdmin },
    });
  }

  public linkBankAccount(bank: BankLink) {
    return HttpService.post("/admin/api/v2/author-bank", {
      body: { ...bank },
    });
  }

  public updateBankAccount(bank: BankLink) {
    return HttpService.patch("/admin/api/v2/author-bank/author", {
      body: { ...bank },
    });
  }

  public changePassword(bodyPassword: ChangePasswordRequest) {
    return HttpService.post("/admin/api/v2/auth/change-password", {
      body: {
        oldPassword: bodyPassword.oldPassword,
        newPassword: bodyPassword.newPassword,
      },
    });
  }

  public sendMfaCode() {
    return HttpService.post<GetDetailResponse<VerifyMfaSendMethodResponse>>(
      "/admin/api/v2/auth/mfa-register"
    );
  }

  public verifyMfaCode(code: string, isVerifyRegister = true) {
    return HttpService.post<GetDetailResponse<VerifyMfaCode>>(
      "/admin/api/v2/auth/mfa-verify-code",
      {
        body: { code, isVerifyRegister },
      }
    );
  }

  public loginSocial(socialLoginRequest: SocialLoginRequest) {
    return HttpService.post<LoginResponse>("/admin/api/v3/oauth/social-media", {
      body: { ...socialLoginRequest },
    });
  }
}

const AuthService = new _AuthService();

export default AuthService;
